// WebVitalsLoader.js
'use strict';
import { connect } from 'react-redux';

import { ENABLE_WEB_VITALS } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import WebVitalsLoader from '../component/WebVitalsLoader.jsx';

const mapStateToProps = state => {
  return {
    enableWebVitals: getRemoteConfigData(state, ENABLE_WEB_VITALS) === 1,
  };
};

export default connect(mapStateToProps)(WebVitalsLoader);
